import React from 'react';
import PropTypes from 'prop-types';
import { trackEvent } from 'src/util/segment-storeless';

const TrackedLink = (props) => {
  const {
    trackName,
    trackProperties,
    children,
    href,
    ...domProps
  } = props;

  const callback = event => () => { window.location.href = event.target.href; };
  const handleClick = (event) => {
    event.preventDefault();
    trackEvent(trackName, trackProperties, callback(event));
  };

  return (
    // We need to specify href and children explicitly or else we get lots of a11y errors
    <a
      href={href}
      onClick={handleClick}
      {...domProps}
    >
      {children}
    </a>
  );
};

TrackedLink.defaultProps = {
  children: null,
};

TrackedLink.propTypes = {
  trackName: PropTypes.string.isRequired,
  trackProperties: PropTypes.objectOf(PropTypes.string).isRequired,
  href: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default TrackedLink;
